import ManagedManagerPermissions from "./ManagedManagerPermissions";
export default ManagedManagerPermissions;
